<template>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">办公系统</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/workflow/flowArticle' }">发文管理</el-breadcrumb-item>
        <el-breadcrumb-item>内部月刊</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="header-bar">
        <span>发文月刊栏目</span>
        <span class="subtitle">
            <!-- {{ new Date().getFullYear() }}年{{ new Date().getMonth() + 1 }}月{{ new Date().getDate() }}日 -->
            <el-button @click="toggleMarket" plain  
                :type="market === 5 ? 'info' : 'default'">领导点评</el-button>

            <el-button plain @click="$router.push({ name: 'articlePusher' })">去发表</el-button>
        </span>
    </div>

    <!-- <div class="top-actions">
        <el-button class="leader-toggle" @click="toggleMarket"
            :type="market === 5 ? 'info' : 'default'">领导点评</el-button>

        <div class="right-actions">
            <el-button @click="$router.push({ name: 'articlePusher' })">去发表</el-button>
        </div>
    </div> -->

    <div class="articles-container">
        <div class="category-section" v-for="category in visibleCategories" :key="category.value">
            <div class="category-header">
                <div class="category-info">
                    <span class="category-title">{{ category.label }}</span>
                    <span class="category-desc">{{ category.desc }}</span>
                </div>
                <div class="category-actions">
                    <el-button size="small" @click="goPrevIssue(category)" :disabled="category.pageIndex <= 1">《上一期》
                    </el-button>
                    <el-button size="small" @click="goNextIssue(category)"
                        :disabled="isLastPage(category)">《下一期》</el-button>
                </div>
            </div>

            <div class="articles-grid">
                <div class="article-card" v-for="item in category.list" :key="item.id"
                    @click="$router.push({ name: 'articleDetail', query: { id: item.id } })">
                    <img :src="getImageUrl(item)" v-if="item.attachments" alt="图片"
                        @error="$event.target.style.display = 'none'"
                        style="width: 100%; height: 150px; object-fit: cover; object-position: center;" />
                    <div class="article-title">{{ item.title }}</div>
                    <div class="article-meta">{{ item.publishDeptName }} {{ item.publishUserName }} {{ item.publishDate
                    }}
                    </div>
                    <div class="article-content">
                        {{ getContentPreview(item.content) }}
                    </div>
                    <el-text class="article-link">查看完整文章--&gt;&gt;</el-text>
                </div>
            </div>

            <div class="category-empty" v-if="!category.list.length">
                <el-empty description="暂无内容..." />
            </div>
        </div>
    </div>
</template>

<script>
const ARTICLE_TYPES = [
    { label: '推荐栏目', value: '推荐', desc: '精选推荐文章，聚焦近期值得关注的重点资讯与亮点成果。' },
    { label: '热门栏目', value: '热门', desc: '浏览量最高的热点内容，快速了解大家都在讨论的事项。' },
    { label: '公告栏目', value: '公告', desc: '公司级正式公告，涵盖制度、政策与重要节点通知。' },
    { label: '通知栏目', value: '通知', desc: '各部门共享的通知信息，帮助您及时掌握协同要求。' },
    { label: '月刊栏目', value: '月刊', desc: '内部月刊精选，全面梳理本月经营、市场与管理动态。' },
    { label: '指引栏目', value: '指引', desc: '操作指南与流程指引，助力快速上手系统与业务。' }
];

export default {
    name: "FlowArticlePaper",
    data() {
        return {
            market: 0,
            baseUrl: process.env.VUE_APP_BASEURL,
            categories: ARTICLE_TYPES.map(type => ({
                ...type,
                pageIndex: 1,
                pageSize: 5,
                records: 0,
                list: [],
                loading: false
            }))
        };
    },
    mounted() {
        this.loadAllCategories(true);
    },
    computed: {
        visibleCategories() {
            return this.categories.filter(category => Array.isArray(category.list) && category.list.length > 0);
        }
    },
    methods: {
        getImageUrl(item) {
            const attachments = item.attachments || '';

            if (attachments == '') {
                return this.baseUrl + 'Static/Code/' + (item.uniqueCode || item.id);
            }

            // 分割附件路径数组
            const attachmentList = attachments.split(';').filter(path => path.trim());

            // 图片扩展名列表
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];

            // 过滤出图片附件
            const imageAttachment = attachmentList.find(path => {
                const lowerPath = path.toLowerCase();
                return imageExtensions.some(ext => lowerPath.endsWith(ext));
            });

            // 如果找到图片附件，返回第一个图片
            if (imageAttachment) {
                // 检查路径是否已经是完整 URL（包含 http 或 https）
                if (imageAttachment.startsWith('http://') || imageAttachment.startsWith('https://')) {
                    return imageAttachment;
                }

                // 确保路径以 / 开头，避免重复拼接
                const normalizedPath = imageAttachment.startsWith('/') ? imageAttachment : '/' + imageAttachment;
                return this.baseUrl.endsWith('/') ? this.baseUrl + normalizedPath.substring(1) : this.baseUrl + normalizedPath;
            }

            // 未找到图片，使用默认图片
            return this.baseUrl + 'Static/Code/' + (item.uniqueCode || item.id);
        },
        getContentPreview(content) {
            if (!content) {
                return '暂无内容...';
            }

            // 过滤 HTML 标签，只保留纯文本
            const text = content.replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/g, ' ')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&amp;/g, '&')
                .replace(/&quot;/g, '"')
                .trim();

            // 截取前 120 个字符
            if (text.length > 120) {
                return text.substring(0, 120) + '...';
            }

            return text || '暂无内容...';
        },
        toggleMarket() {
            this.market = this.market === 5 ? 0 : 5;
            this.loadAllCategories(true);
        },
        loadAllCategories(resetPage = false) {
            this.categories.forEach(category => {
                if (resetPage) {
                    category.pageIndex = 1;
                }
                this.loadCategory(category);
            });
        },
        loadCategory(category) {
            if (!category) return;
            category.loading = true;
            this.$kaung.fetch({
                url: '/FlowArticle/PublicList',
                method: 'post',
                params: {
                    page: category.pageIndex,
                    market: this.market,
                    rows: category.pageSize,
                    type: category.value
                }
            }).then((res) => {
                const resData = res.data || {};
                category.pageIndex = resData.page || category.pageIndex;
                category.pageSize = resData.rows || category.pageSize;
                category.records = resData.records || 0;
                category.list = resData.data || [];
            }).finally(() => {
                category.loading = false;
            });
        },
        goPrevIssue(category) {
            if (!category || category.pageIndex <= 1) {
                return;
            }
            category.pageIndex -= 1;
            this.loadCategory(category);
        },
        goNextIssue(category) {
            if (!category || this.isLastPage(category)) {
                return;
            }
            category.pageIndex += 1;
            this.loadCategory(category);
        },
        isLastPage(category) {
            if (!category) return true;
            if (category.records) {
                const totalPages = Math.max(1, Math.ceil(category.records / category.pageSize));
                return category.pageIndex >= totalPages;
            }
            return category.list.length < category.pageSize;
        }
    }
};
</script>

<style scoped>
.header-bar {
    background: #6d3c3c;
    color: #fff;
    padding: 16px 24px;
    font-size: 2rem;
    font-weight: bold;
    /* display: flex; */
    flex-direction: column;
    /* gap: 30px; */
    margin-top: 20px
}

.header-bar .subtitle {
    font-size: 1rem;
    font-weight: normal;
    margin-top: 4px;
    margin-left: 10px;
    float: inline-end;
}


.top-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 16px 0;
}

.top-actions .el-button {
    /* background: #fff; */
    color: #6d3c3c;
    border: 2px solid #6d3c3c;
    border-radius: 6px;
}

.top-actions .el-button.active,
.top-actions .el-button:hover,
.top-actions .el-button--info {
    background: #6d3c3c;
    color: #fff;
}

.articles-container {
    margin-top: 12px;
}

.category-section {
    margin-bottom: 36px;
}

.category-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.category-info {
    display: flex;
    flex-direction: row;
    gap: 15px;
    line-height: 30px;
}

.category-title {
    font-size: 1.4rem;
    font-weight: 600;
    color: #333;
}

.category-desc {
    font-size: 0.9rem;
    color: #8c8c8c;
    margin-top: 2px;
}

.category-actions .el-button {
    border-color: #6d3c3c;
    color: #6d3c3c;
}

.category-actions .el-button.is-disabled {
    border-color: #ddd;
    color: #bbb;
}

.articles-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 24px;
}

.category-empty {
    padding: 16px 0;
}

.article-card {
    background: #f3f3f3;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    cursor: pointer;
}

.article-card img {
    width: 100%;
    height: 160px;
    object-fit: cover;
    border-radius: 8px;
    background: #e0e0e0;
}

.article-title {
    font-size: 1.3rem;
    font-weight: bold;
    color: #333;
    cursor: pointer;
}

.article-meta {
    font-size: 0.9rem;
    color: #888;
}

.article-content {
    font-size: 1rem;
    color: #444;
    margin-top: 8px;
    margin-bottom: 8px;
}

.article-link {
    font-size: 0.95rem;
    color: #6d3c3c;
    text-align: right;
    cursor: pointer;
    display: block;
    width: 100%;
}

.articles-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-top: 24px;
}

@media (max-width: 1200px) {
    .articles-grid {
        grid-template-columns: 1fr;
    }

    .articles-list {
        grid-template-columns: 1fr;
    }
}
</style>
